import React from 'react';
import { PASSWORD_RULES } from '../../utils/passwordPolicy';

interface PasswordRequirementsProps {
  password: string;
}

/** Чек-лист требований к паролю: пункты отмечаются по мере ввода. */
const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password }) => (
  <ul className="password-requirements" aria-label="Требования к паролю">
    {PASSWORD_RULES.map((rule) => {
      const ok = rule.test(password);
      return (
        <li
          key={rule.id}
          className={`password-requirements__item${ok ? ' password-requirements__item--ok' : ''}`}
        >
          <span className="password-requirements__mark" aria-hidden="true">{ok ? '✓' : '○'}</span>
          {rule.label}
        </li>
      );
    })}
  </ul>
);

export default PasswordRequirements;
